/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockPurchaseorderExportCtrl
 */
angular.module('mercury.modules.stock.purchaseorder')
.controller('StockPurchaseorderExportCtrl', ["dialog", "$q", "reporttime", "$scope", "$state", "$stateParams", "StockPurchaseOrders", "StockSupplierStatements", "title", function(dialog, $q, reporttime, $scope, $state, $stateParams, StockPurchaseOrders, StockSupplierStatements, title) {
  title.set('Export Invoices');
  reporttime.defaultType = 'week';

  $scope.report = $stateParams.report;

  $scope.allOrders = StockPurchaseOrders.getArchive(reporttime.start(), reporttime.end());
  $scope.allStatements = StockSupplierStatements.getAll(reporttime.start(), reporttime.end());

  $scope.suppliers = [];
  $scope.supplierOrders = {};
  $scope.supplierStatements = {};

  $scope.loading = $q.all([$scope.allOrders.$promise, $scope.allStatements.$promise]);
  $scope.loading.then(function() {
    var suppliers = {};

    angular.forEach($scope.allOrders, function(order) {
      if (!$scope.supplierOrders[order.supplierId]) {
        $scope.supplierOrders[order.supplierId] = [];
      }
      $scope.supplierOrders[order.supplierId].push(order);

      suppliers[order.supplierId] = order.supplierName;
    });

    angular.forEach($scope.allStatements, function(statement) {
      if (!$scope.supplierStatements[statement.supplierId]) {
        $scope.supplierStatements[statement.supplierId] = [];
      }
      $scope.supplierStatements[statement.supplierId].push(statement);

      suppliers[statement.supplierId] = statement.supplierName;
    });

    angular.forEach(suppliers, function(supplierName, supplierId) {
      $scope.suppliers.push({id: supplierId, name: supplierName});
    });

    $scope.statementsExist = $scope.allStatements.length > 0;
    $scope.exportView = ($scope.statementsExist) ? 'statements' : 'orders';
    $scope.combine = 'true';
    $scope.accountingSystem = 'xero';
  });

  $scope.supplierSelected = function(supplier) {
    var selected = 0;
    if ($scope.exportView == 'statements') {
      angular.forEach($scope.supplierStatements[supplier.id], function(statement) {
        if (statement.toExport) {
          selected += 1;
        }
      });
    } else {
      angular.forEach($scope.supplierOrders[supplier.id], function(order) {
        if (order.toExport) {
          selected += 1;
        }
      });
    }
    return selected;
  };

  $scope.supplierTotal = function(supplier) {
    var total = 0;
    if ($scope.exportView == 'statements') {
      angular.forEach($scope.supplierStatements[supplier.id], function(statement) {
        if (statement.toExport) {
          total += statement.reconciledAmount;
        }
      });
    } else {
      angular.forEach($scope.supplierOrders[supplier.id], function(order) {
        if (order.toExport) {
          total += order.total;
        }
      });
    }
    return total;
  };

  /**
  * Set all orders and statements for this supplier to be exported.
  */
  $scope.checkSupplier = function(supplier) {
    angular.forEach($scope.supplierStatements[supplier.id], function(statement) {
      statement.toExport = supplier.toExport;
    });

    angular.forEach($scope.supplierOrders[supplier.id], function(order) {
      order.toExport = supplier.toExport;
    });

  };

  /**
  * Redirect to the xero export screen with the needed scope data set based on selections.
  */
  $scope.exportToSystem = function() {
    var ToExport = [];
    var suppliers = {};

    angular.forEach($scope.suppliers, function(supplier) {
      if ($scope.exportView == 'statements') {
        angular.forEach($scope.supplierStatements[supplier.id], function(statement) {
          if (statement.toExport) {
            ToExport.push(statement.id);
            suppliers[statement.supplierId] = true;
          }
        });
      } else {
        angular.forEach($scope.supplierOrders[supplier.id], function(order) {
          if (order.toExport) {
            ToExport.push(order.id);
            suppliers[order.supplierId] = true;
          }
        });
      }
    });

    if (ToExport.length === 0) {
      dialog.alert('You need to select at least one ' + $scope.exportView + ' to export.');
    } else {
      //Put the data in the root scope so each export controller can access it. Might move to service later.
      var exportData = {
        type: $scope.exportView,
        combine: $scope.combine == 'true',
        ids: angular.copy(ToExport),
        suppliers: Object.keys(suppliers)
      };

      $state.go('Stock.XeroPurchaseOrder', {exportData: JSON.stringify(exportData), report: $stateParams.report});
    }
  };

  $scope.getOrderXeroLink = function(purchaseOrder) {
    if (purchaseOrder.total < 0) {
      return 'https://go.xero.com/AccountsPayable/EditCreditNote.aspx?creditNoteID=' + purchaseOrder.xeroInvoiceId;
    } else {
      return 'https://go.xero.com/AccountsPayable/Edit.aspx?InvoiceID=' + purchaseOrder.xeroInvoiceId;
    }
  };

  $scope.getStatementXeroLink = function(statement) {
    if (statement.reconciledAmount < 0) {
      return 'https://go.xero.com/AccountsPayable/EditCreditNote.aspx?creditNoteID=' + statement.xeroInvoiceId;
    } else {
      return 'https://go.xero.com/AccountsPayable/Edit.aspx?InvoiceID=' + statement.xeroInvoiceId;
    }
  };

  $scope.unlinkPurchaseOrder = function(order) {
    StockPurchaseOrders.unlinkFromXero(order)
    .then(function() {
      order.xeroInvoiceId = null;
    });
  };

  $scope.unlinkStatement = function(statement) {
    StockSupplierStatements.unlinkFromXero(statement)
    .then(function() {
      statement.xeroInvoiceId = null;
    });
  };
}]);
